module.exports = __webpack_public_path__ + "media/images/content/pic_direction_ne-dced3fa186a23f2d8f6da1b538152eda.svg";